import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';

// Shared UI Library Components
import { Paginator } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './transactions-list.scss';

// Components
import { TransactionsItem } from '../transactions-item/transactions-item';

// Store
import { getTransactions } from '../../../../store/transactions/transactions.thunks';

// Models
import { ITransactionItem, ITransactionSettings } from '../../../../interfaces/transactions.interfaces';

type TTransactionsListProps = {
  transactionsList: ITransactionItem[];
  transactionsSettings: ITransactionSettings;
  total: number;
  loading?: boolean;
};

export const TransactionsList: FC<TTransactionsListProps> = (
  { transactionsList, transactionsSettings, total, loading = false }: TTransactionsListProps
): JSX.Element => {
  const [page, setPage] = useState<number>(1);

  const transformedList: ITransactionItem[] = transactionsList;

  const dispatch = useDispatch<any>();

  const onPageChange = (currentPage: number) => {
    if (page !== currentPage) {
      setPage(currentPage);
      dispatch(getTransactions({
        settings: {
          ...transactionsSettings,
          offset: (currentPage - 1) * 10,
          limit: 10,
        }
      }));
      return;
    }
    setPage(1);
  };

  return (
    <div className={ `transactions-list` }>

      { !transformedList.length && <div className="transactions-list--empty">
        No data to display
      </div> }

      <div className="transactions-list--body">
        {
          transformedList
            .map(transaction =>
              <TransactionsItem key={ transaction.id }
                                transaction={ transaction }
              />)
        }
      </div>

      { total > 10 && <div className="transactions-list--pagination">
        <Paginator totalItems={ total } pageChange={ onPageChange }/>
      </div>
      }
    </div>
  );
};
